import { Component, OnInit, forwardRef, Input, ViewChild, ElementRef, Injector, AfterViewInit } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, FormControl, NgControl } from '@angular/forms';

@Component({
  selector: 'ngx-cm-block-checkbox',
  templateUrl: './ngx-cm-block-checkbox.component.html',
  styleUrls: ['./ngx-cm-block-checkbox.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => NgxCmBlockCheckboxComponent),
    multi: true
  }]
})
export class NgxCmBlockCheckboxComponent implements ControlValueAccessor, OnInit, AfterViewInit {
  contextValue;
  onChange;

  @Input()
  Value = false;

  @Input()
  Label = '';

  @Input()
  Group = false;
  ValueGroup = [];

  @ViewChild('chk', { static: true, read: ElementRef }) chk;

  control: FormControl;

  constructor(
    private injector: Injector
  ) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    if (this.Group) {
      let ngControl = this.injector.get(NgControl, null);
      if (ngControl) {
        this.control = ngControl.control as FormControl;
        this.control.valueChanges.subscribe(value => {
          this.ValueGroup = value;
        });
      }
    }
  }

  registerOnChange(fn) {
    this.onChange = fn;
  }

  registerOnTouched(fn) { }

  writeValue(value) {
    if (this.Group) {
      this.ValueGroup = value ? value : [];
      if (this.ValueGroup.indexOf(this.Value) != -1) {
        this.contextValue = this.Value;
      } else {
        this.contextValue = null;
      }
    } else {
      this.contextValue = value;
    }
  }

  updateValue(checked) {
    if (!checked) {
      this.chk.nativeElement.checked = true;
      this.contextValue = this.Value;
      if (this.onChange) {
        if (this.Group) {
          this.ValueGroup = Object.assign([], this.ValueGroup);
          this.ValueGroup.push(this.Value);
          this.onChange(this.ValueGroup);
        } else {
          this.onChange(this.Value);
        }
      }
    } else {
      this.chk.nativeElement.checked = false;
      this.contextValue = null;
      if (this.onChange) {
        if (this.Group) {
          this.ValueGroup = Object.assign([], this.ValueGroup);
          this.ValueGroup.splice(this.ValueGroup.indexOf(this.Value), 1);
          this.onChange(this.ValueGroup);
        } else {
          this.onChange(null);
        }
      }
    }
  }
}
